import { useState } from 'react'
import { Accordion, Button, Container, Title } from '@/components'

import { FAQ } from './constants'

import styles from './styles.module.scss'

const dividirArrayEmDuasPartes = (array = []) => {
  const meio = Math.ceil(array.length / 2)
  const primeiraParte = array.slice(0, meio)
  const segundaParte = array.slice(meio)
  return [primeiraParte, segundaParte]
}

const Faq = ({ faq = 'default', separator = true }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [faq1, faq2] = dividirArrayEmDuasPartes(FAQ[faq])

  return (
    <section className={styles.faq} id="faq">
      <Container>
        {separator && <hr className={styles.separator} />}


        <Title Tag="h2" alignText="left" customClass={styles.faq__title}>
          DÚVIDAS? NOSSO TIME RESPONDE
        </Title>

        <div className={`${styles.faq__list} ${isOpen && styles.faq__isOpen}`}>
          <div className={styles.faq__content}>
            {faq1.map(({ title, content }, index) => (
              <Accordion
                customClass={styles.faq['__content--item']}
                id={`faq-item${index + 1}-accordion`}
                key={`faq-${index}`}
                title={title}
              >
                {content}
              </Accordion>
            ))}
          </div>

          <div
            className={`${styles.faq__content} ${isOpen && styles.faq__isOpen}`}
          >
            {faq2.map(({ title, content }, index) => (
              <Accordion
                customClass={styles.faq['__content--item']}
                id={`faq-item${index + 1}-accordion`}
                key={`faq-${index}`}
                title={title}
              >
                {content}
              </Accordion>
            ))}
          </div>
        </div>

        <Button
          variant="transparent"
          className={styles.faq__expand}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? 'Ver menos' : 'Ver mais +'}
        </Button>
      </Container>
    </section>
  )
}

export default Faq
